import { useState } from "react";
import styled from "styled-components";
import NetworkConfig from "../../../../settings/venue/device/NetworkConfig/NetworkConfig";
import Modal from "../../../../UiComponents/Modal";
import { editableColor, readOnlyColor } from "../../../fields/Styles";
import { FieldButton } from "../../../fields/styling/FieldStyles";
import { interfaceKeys } from "../../../../settings/venue/device/NetworkConfig/networkConfigTypes";
import { ModalContainer } from "../../../../panel/ModalStyles";

const FieldContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

const NetworkConfigField = ({ hub, updateHub, customerId }) => {
    const [showModal, setShowModal] = useState(false);

    const isConfigured = checkConfigured(hub.networkConfig);
    return <>
        <FieldContainer>

            <div style={{ color: isConfigured ? editableColor : readOnlyColor }}>{isConfigured ? 'Configured' : 'Default'}</div>
            <div>
                <FieldButton tertiary small onClick={() => setShowModal(true)}>View Config</FieldButton>
            </div>
        </FieldContainer>
        <Modal show={showModal} close={() => setShowModal(false)}>
            <ModalContainer>
                <NetworkConfig
                    hub={hub}
                    customerId={customerId}
                    readOnly={false}
                    refreshDevices={() => { }}
                />
            </ModalContainer>
        </Modal>
    </>
}

export default NetworkConfigField;

const checkConfigured = (networkConfig) => {
    if (networkConfig) {
        const hasVirutalInterface = networkConfig?.[interfaceKeys.ETH0_VIRTUAL] !== undefined || networkConfig?.[interfaceKeys.WLAN0_VIRTUAL] !== undefined;
        const hasStaticAddress = Object.values(interfaceKeys).filter(key => networkConfig[key]?.isStatic) > 0;
        return hasVirutalInterface || hasStaticAddress;
    } else {
        return false;
    }
}